import { API } from "aws-amplify";
import { lookup as lookupGqlQuery } from "../../graphql/queries";
import { GraphQLQuery } from "@aws-amplify/api";
import { LookupQuery, LookupResponse } from "../../API";
import { useCallback } from "react";

export function useLookup() {
    const lookup = useCallback(
        async (email: string): Promise<Partial<LookupResponse>> => {
            const result = await API.graphql<GraphQLQuery<LookupQuery>>({
                query: lookupGqlQuery,
                variables: { email },
            });

            if (!result.data?.lookup) {
                return {};
            }

            return result.data?.lookup;
        },
        []
    );

    return { lookup };
}
